// Shared helpers for booking WhatsApp actions (used by Bookings list + Calendar day view)

export const waDigits = (p) => {
  const d = (p || "").replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};

// "14:00" -> "2:00 PM"
export const fmtTime12 = (t) => {
  if (!t) return "";
  const m = String(t).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return t;
  let h = parseInt(m[1], 10);
  const suffix = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m[2]} ${suffix}`;
};

// "2026-10-02" -> "02 Oct 2026"
export const fmtDate = (d) => {
  if (!d) return "";
  const dt = new Date(`${d}T00:00:00`);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const whenLine = (b) => (b.date ? `${fmtDate(b.date)}${b.time ? ` at ${fmtTime12(b.time)}` : ""}` : (b.timing || ""));

export const confirmMsg = (b) => {
  const lines = [
    `✨ *Booking Confirmed* ✨`,
    ``,
    `Hi ${b.name}! ❤️`,
    ``,
    `Great news - your appointment at VIIMII STUDIO is confirmed.`,
    ``,
  ];
  if (b.date) lines.push(`📅 *Date:* ${fmtDate(b.date)}`);
  if (b.time) lines.push(`🕐 *Time:* ${fmtTime12(b.time)}`);
  lines.push(`💅 *Service:* ${b.service || "General"}`);
  const sel = (b.message || "").split(" | ").find((p) => p.startsWith("Selected:"));
  if (sel) lines.push(`✨ *Booked:* ${sel.replace("Selected:", "").trim()}`);
  if (b.amount) lines.push(``, `💰 *Estimated Total:* ₹${Number(b.amount).toLocaleString("en-IN")}`);
  lines.push(``, `We can't wait to pamper you. See you soon! ❤️`, ``, `- VIIMII STUDIO`);
  return lines.join("\n");
};

export const waitingMsg = (b) => {
  const lines = [
    `Hi ${b.name}! ❤️`,
    ``,
    `We've received your appointment request at VIIMII STUDIO.`,
    ``,
  ];
  const w = whenLine(b);
  if (w) lines.push(`📅 *Requested:* ${w}`);
  lines.push(`💅 *Service:* ${b.service || "General"}`);
  lines.push(``, `We're confirming your slot and will update you shortly. Thank you!`, ``, `- VIIMII STUDIO`);
  return lines.join("\n");
};

export const declineMsg = (b) => {
  const w = whenLine(b);
  const link = `${window.location.origin}/?rebook=1`;
  const lines = [
    `Hi ${b.name},`,
    ``,
    `We're really sorry - your appointment at VIIMII STUDIO${w ? ` (${w})` : ""} couldn't be confirmed and has been cancelled.`,
    ``,
    `We'd love to reschedule you! Tap below to pick a new slot:`,
    link,
    ``,
    `- VIIMII STUDIO`,
  ];
  return lines.join("\n");
};

export const waCustomer = (b, msg) => `https://wa.me/${waDigits(b.phone)}?text=${encodeURIComponent(msg)}`;
